import { render, staticRenderFns } from "./StButtonLink.vue?vue&type=template&id=a9bbbdde"
import script from "./StButtonLink.vue?vue&type=script&lang=ts"
export * from "./StButtonLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports